module.exports = __webpack_public_path__ + "media/images/photography/ty-inspired-562eff9c561604338a5258726ce2668d.jpg";